const CATEGORIES = [
  {
    value: 1,
    key: 1,
    text: 'All',
  },
  {
    value: 2,
    key: 2,
    text: 'Responsible AI 7%',
  },
  {
    value: 3,
    key: 3,
    text: 'GitHub Copilot plans and features 31%',
  },
  {
    value: 4,
    key: 4,
    text: 'Privacy fundamentals and context exclusions 15%',
  },
  {
    value: 5,
    key: 5,
    text: 'Prompt crafting and Prompt data 9%',
  },
  {
    value: 6,
    key: 6,
    text: 'Testing with GitHub Copilot 9%',
  },
  {
    value: 7,
    key: 7,
    text: 'How GitHub Copilot works and handles data 15%',
  },
  {
    value: 8,
    key: 8,
    text: 'Developer use cases for AI 14%',
  },
];

export default CATEGORIES;
